export const passwordRegex = {
  exp: '^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$*.{}?"!@#%&/,><\':;|_~`^\\-\\]\\[\\)\\(\\+\\=\\\\]).{8,}',
  err: 'The password must be at least 8 characters long and have at least one of the following: number, uppercase letter, lowercase letter, and a special character.',
};
export const alphaNumericRegex = {
  exp: "^[0-9a-zA-Z]+(([',. -][0-9a-zA-Z ])?[0-9a-zA-Z]*)*$",
  err: 'Alphabetic characters or Numbers only',
};
